import classNames from 'classnames';
import styles from '../styles/components/loader.module.scss';

const Loader = ({
  small = false,
  white = false,
  center = false,
  middle = false,
  showCog = false,
  overlay = false,
  title = "Loading...",
  className = "",
}) => {

  if (showCog) {
    return (
      <div className={classNames(className, {
        [styles.overlay]: overlay
      })}>
        <div className={classNames(styles.cogLoaderWrapper, {
          [styles.middle]: middle,
          [styles.center]: center,
        })}>
          <div className={styles.innerWrapper}>
            <div className={styles.centerWrapper}>
              <div className={styles.cogLoader} />
            </div>
            <div className={styles.centerWrapper}>
              <div className={styles.loadingTitle}>{title}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classNames(className, {
      [styles.overlay]: overlay
    })}>
      <div className={classNames(styles.loader, {
        [styles.small]: small,
        [styles.white]: white,
        [styles.middle]: middle,
        [styles.center]: center,
        [className]: className,
      })} />
    </div>
  )
};

export default Loader;
